const updateTemplate = require("./update.html.slim")
declare var angular

export class TwoFactorUpdate {
  static $inject = ['$rootScope', '$scope', 'users', '$resource', '$location']

  password: string;
  step: string;
  title: string;
  pillStep: number;
  tfaMethod: string;
  tfaInfo: any;

  code: string;
  phone: string;
  qrCode: string;

  state: string;
  error: string;
  errorMaxRetries: string;
  loading: string;

  constructor(
    public $rootScope,
    public $scope,
    private users,
    private $resource,
    private $location
  ) {
    $rootScope.$on('updateTwoFactor', ((event, { tfaInfo }) => {
      this.password = '';
      this.title = 'Update Two-step';
      this.step = 'start'
      this.pillStep = 1
      this.phone = tfaInfo.phoneNumber
      this.state = ''
      this.error = null
      this.errorMaxRetries = ''
      this.tfaInfo = tfaInfo
      this.tfaMethod = tfaInfo.method
      this.loading = '';
      this.$scope.twoFactorUpdateDialog.show();
    }));
  }

  async confirmCode() {
    this.state = "submitting";
    try {
      await this.$resource('/api/two-factor-auth/confirm-phone-update').save({ token: this.code }).$promise
      this.next('success');
      this.code = '';
      this.error = null;
      this.state = "";
    } catch ({ data }) {
      this.error = data.message;
      this.code = '';
      this.state = "";
    }
  }

  async requestCode(phone) {
    this.loading = 'loading';
    try {
      await this.$resource('/api/two-factor-auth/verify-phone-update').save({ password: this.password, phone: this.phone }).$promise
      if(this.step !== 'confirm') {
        this.next('confirm');
      }
      this.loading = "loaded";
      this.state = '';
      this.error = null;
    } catch ({ data }) {
      this.loading = "";
      if (data.error_code && data.error_code === 'max_retries_reached') {
        this.errorMaxRetries = data.message;
        this.resetSendError();
        this.state = '';
        this.error = null;
      }else{
        this.state = 'error';
        this.error = data.message;
      }
    }
  }

  resetSendError() {
    setTimeout(() => { 
      this.errorMaxRetries = '';
    }, 120000);
  }

  done() {
    this.$rootScope.$emit("update_tfa_dashboard")
    this.$location.search({})
    this.$scope.twoFactorUpdateDialog.hide();
  }


  next(step) {
    this.error = null;
    this.state = '';
    this.step = step;
    this.pillStep++;
  }

  back(step) {
    this.step = step;
    this.pillStep--;
  }
}

angular.module('wbComponents').directive('twoFactorAuthUpdate', function () {
  return {
    restrict: 'E',
    templateUrl: updateTemplate,
    controller: TwoFactorUpdate,
    controllerAs: 'update',
    bindToController: true
  }
})
